import React from 'react';
import {
  Box,
  theme,
  Flex,
  Text,
  Link,
  Input,
  FormMessage,
  Label,
} from '@xometry/xometry_loft';
import TooltipBlueIcon from '../../../../../components/TooltipBlueIcon';

const BillingContact = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  billingContactEditMode,
  setBillingContactEditMode,
}) => {
  return (
    <Box
      borderBottom={`1px solid ${theme.colors.darkBlues[25]}`}
      marginBottom="28px"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        marginBottom="8px"
      >
        <Text kind="body-title">Billing Contact Information</Text>
        <Link
          onClick={() => setBillingContactEditMode(!billingContactEditMode)}
        >
          {!billingContactEditMode ? 'Edit' : 'Save Changes'}
        </Link>
      </Flex>
      <Box marginBottom="16px">
        <Text kind="body-sm">
          Fill out the information needed to contact your Accounts Payable team.
        </Text>
      </Box>
      {!billingContactEditMode && (
        <>
          <Flex marginBottom="4px">
            <Text
              kind="body-sm-title"
              marginRight="4px"
              fontWeight={theme.fontWeights.semibold}
            >
              Entity Name:
            </Text>
            <Text kind="body-sm">{values.entityName}</Text>
          </Flex>
          <Flex marginBottom="4px">
            <Text
              kind="body-sm-title"
              marginRight="4px"
              fontWeight={theme.fontWeights.semibold}
            >
              Accounts Payable Phone Number:
            </Text>
            <Text kind="body-sm">{values.acctsPayablePhone}</Text>
          </Flex>
          <Flex marginBottom="28px">
            <Text
              kind="body-sm-title"
              marginRight="4px"
              fontWeight={theme.fontWeights.semibold}
            >
              Accounts Payable Email:
            </Text>
            <Text kind="body-sm">{values.acctsPayableEmail}</Text>
          </Flex>
        </>
      )}
      {billingContactEditMode && (
        <Box marginBottom="28px" width="70%">
          <Flex>
            <Label htmlFor="entityName">Entity Name</Label>
            <TooltipBlueIcon>
              Use the entity name registered with the IRS.
            </TooltipBlueIcon>
          </Flex>
          <Input
            width="100%"
            className="pii-encrypt"
            id="entityName"
            marginBottom="16px"
            value={values.entityName}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={Boolean(touched.entityName && errors.entityName)}
          />
          {Boolean(touched.entityName && errors.entityName) && (
            <FormMessage invalid>{errors.entityName}</FormMessage>
          )}
          <Flex marginBottom="28px">
            <Box marginRight="8px" width="100%">
              <Label htmlFor="acctsPayableEmail">Accounts Payable Email</Label>
              <Input
                width="100%"
                className="pii-encrypt"
                id="acctsPayableEmail"
                value={values.acctsPayableEmail}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={Boolean(
                  touched.acctsPayableEmail && errors.acctsPayableEmail
                )}
              />
              {Boolean(
                touched.acctsPayableEmail && errors.acctsPayableEmail
              ) && (
                <FormMessage invalid>{errors.acctsPayableEmail}</FormMessage>
              )}
            </Box>
            <Box width="100%">
              <Label htmlFor="acctsPayablePhone">
                Accounts Payable Phone Number
              </Label>
              <Input
                width="100%"
                className="pii-encrypt"
                id="acctsPayablePhone"
                marginBottom="4px"
                value={values.acctsPayablePhone}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={Boolean(
                  touched.acctsPayablePhone && errors.acctsPayablePhone
                )}
              />
              {Boolean(
                touched.acctsPayablePhone && errors.acctsPayablePhone
              ) && (
                <FormMessage invalid>{errors.acctsPayablePhone}</FormMessage>
              )}
            </Box>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default BillingContact;
